/* eslint-disable @typescript-eslint/no-explicit-any */
import { HStack, Heading, VStack, Button, Image } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { IPromotionCard } from '@/service/club/types';
import { cacheBust } from '@/utils/cacheBust';

const typeNames: any = {
  buy_and_gain: 'Compre e Ganhe',
  discount: 'Usar Desconto',
  gift: 'Presente',
};

export function CardPromotions({ isMobile, name, image, type, discount, onClick }: IPromotionCard) {
  const { colors } = useTheme();

  return (
    <HStack
      height="120px"
      bg="white"
      borderRadius={'16px'}
      boxShadow={'4px 4px 10px 0px #0000002E'}
      width={'100%'}
      spacing={0}
    >
      <Image src={cacheBust(image)} width={isMobile ? '35%' : '150px'} height={'100%'} borderRadius={'16px 0 0 16px'} />
      <VStack flex={1} spacing={4} padding={'10px'}>
        <HStack align={'flex-start'} justifyContent={'space-between'} width={'100%'}>
          <Text noOfLines={2} fontFamily={'Glory'} fontWeight="500" fontSize={{
            base: '16px',
            md: '20px',
          }}>
            {name}
          </Text>

          {discount > 0 && (
            <HStack
              borderRadius={'100%'}
              align={'center'}
              backgroundColor={colors.primaryColor}
              minWidth={'55px'}
              gap={0}
              minHeight={'55px'}
              justifyContent={'center'}
            >
              <VStack spacing={0} gap={0}>
                <Text fontSize={9} marginLeft="auto" letterSpacing={'-0.04em'} fontWeight={'bold'} color="white">
                  Até
                </Text>
                <Heading
                  fontSize={24}
                  letterSpacing={'-0.05em'}
                  fontWeight={'bold'}
                  fontFamily={'Glory'}
                  lineHeight={'20px'}
                  marginLeft={'5px'}
                  color="white"
                >
                  {discount}
                </Heading>
              </VStack>
              <Text
                fontSize={9}
                letterSpacing={'-0.04em'}
                fontWeight={'bold'}
                color="white"
                sx={{ transform: 'rotate(-90deg) translate(0, -10%)' }}
              >
                % OFF
              </Text>
            </HStack>
          )}
        </HStack>
        <Button
          width={'100%'}
          sx={{
            '&:hover': {
              textDecoration: 'none',
            },
          }}
          onClick={onClick}
          variant={'link'}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <Text fontWeight={600} textTransform={'uppercase'} color={colors.primaryColor}>
            {typeof typeNames[type] !== 'undefined' ? typeNames[type] : 'Usar Desconto'}
          </Text>
          <IoIosArrowRoundForward color={colors.primaryColor} size={30} />
        </Button>
      </VStack>
    </HStack>
  );
}
